(function (w, $) {

    const assetId = '~/Parts/Views/Custom/Site/MyPageMenu.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    var classes = {
        menu: 'profile-quick-menu',
        menuActive: 'profile-quick-menu_active',

        btn: 'profile-quick-menu__btn',

        dropdown: 'profile-quick-menu__dropdown',

        chevronDown: 'profile-quick-menu__un-chevron-down',
        chevronDownActive: 'profile-quick-menu__un-chevron-down_active',
    };

    function _toggleDropDown($target) {
        $target.find('.' + classes.dropdown)
            .slideToggle('fast')
            .end()
            .toggleClass(classes.menuActive)
            .find('.' + classes.chevronDown)
            .toggleClass(classes.chevronDownActive);
    }

    $(function () {
        for (let ctx of w.umwAssets[assetId]) {

            let $TargetProfileQuickMenu = null;

            $('#' + ctx.controlId)
                .on('click', '.' + classes.btn, function(e) {
                    e.preventDefault();
                    $TargetProfileQuickMenu = $(e.target).closest('.' + classes.menu);
                    _toggleDropDown($TargetProfileQuickMenu);
                })
                .keyup(function (e) {
                    if (e.key === 'Escape') { // escape key maps to keycode '27'
                        if ($TargetProfileQuickMenu && $TargetProfileQuickMenu.hasClass(classes.menuActive)) {
                            _toggleDropDown($TargetProfileQuickMenu);
                        }
                    }
                });
        }
    });

})(window, jQuery);